import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "OwaGroupSharedActions" */ "./lazyIndex"), { name: "OwaGroupSharedActions" });

export const lazyLoadUnifiedGroupsSettings: LazyAction<typeof lazyIndex.loadUnifiedGroupsSettings, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadUnifiedGroupsSettings);

export const lazyGetGroupDetailsAction: LazyAction<typeof lazyIndex.getGroupDetailsAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.getGroupDetailsAction);

export const lazyGetGroupMembershipRequests: LazyAction<typeof lazyIndex.getGroupMembershipRequests, typeof lazyModule> = new LazyAction(lazyModule, m => m.getGroupMembershipRequests);

export const lazyUpdateFolderRulePermissionAllGroup: LazyAction<typeof lazyIndex.updateFolderRulePermissionAllGroup, typeof lazyModule> = new LazyAction(lazyModule, m => m.updateFolderRulePermissionAllGroup);

export const lazyLoadGroupInformation: LazyAction<typeof lazyIndex.loadGroupInformation, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadGroupInformation);

export const lazyLeaveGroupAction: LazyAction<typeof lazyIndex.leaveGroupAction, typeof lazyModule> = new LazyAction(lazyModule, m => m.leaveGroupAction);
